const MONDAY = 1
const TUESDAY = 2
const FRIDAY = 5
const KEY_TO_WORKS_DAYS = 10
const WORKS_DURATION_DAYS = 28

export interface StoreProjectWorksDates {
  keyReceptionDate?: string | null
  workStartDate?: string | null
  workEndDate?: string | null
  openingDate?: string | null
}

const parseDateUTC = (dateStr: string): Date => {
  const [year, month, day] = dateStr.split('-').map(Number)
  return new Date(Date.UTC(year, month - 1, day))
}

const formatDateUTC = (date: Date): string => {
  const y = date.getUTCFullYear()
  const m = String(date.getUTCMonth() + 1).padStart(2, '0')
  const d = String(date.getUTCDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

const addDaysUTC = (date: Date, days: number): Date => {
  const d = new Date(date)
  d.setUTCDate(d.getUTCDate() + days)
  return d
}

const nextWeekdayOnOrAfter = (date: Date, weekday: number): Date => {
  const d = new Date(date)
  const diff = (weekday - d.getUTCDay() + 7) % 7
  d.setUTCDate(d.getUTCDate() + diff)
  return d
}

const nextWeekdayAfter = (date: Date, weekday: number): Date =>
  nextWeekdayOnOrAfter(addDaysUTC(date, 1), weekday)

export const computeWorkStartDate = (keyReceptionDate: string): string | null => {
  if (!keyReceptionDate) return null
  const base = addDaysUTC(parseDateUTC(keyReceptionDate), KEY_TO_WORKS_DAYS)
  return formatDateUTC(nextWeekdayOnOrAfter(base, MONDAY))
}

export const computeWorkEndDate = (workStartDate: string): string | null => {
  if (!workStartDate) return null
  const base = addDaysUTC(parseDateUTC(workStartDate), WORKS_DURATION_DAYS)
  return formatDateUTC(nextWeekdayOnOrAfter(base, FRIDAY))
}

export const computeOpeningDate = (workEndDate: string): string | null => {
  if (!workEndDate) return null
  return formatDateUTC(nextWeekdayAfter(parseDateUTC(workEndDate), TUESDAY))
}

export const resolveWorkStartDate = (
  worksData: StoreProjectWorksDates | null | undefined,
): string | null =>
  worksData?.workStartDate || computeWorkStartDate(worksData?.keyReceptionDate ?? '')

export const resolveWorkEndDate = (
  worksData: StoreProjectWorksDates | null | undefined,
): string | null =>
  worksData?.workEndDate || computeWorkEndDate(resolveWorkStartDate(worksData) ?? '')

export const resolveOpeningDate = (
  worksData: StoreProjectWorksDates | null | undefined,
): string | null =>
  worksData?.openingDate || computeOpeningDate(resolveWorkEndDate(worksData) ?? '')
